import { useSignupState } from './useSignupState'

export const useNextStage = () => useSignupState().onboarding?.nextStage
